var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAstraLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M432 250C432 350.516 350.516 432 250 432C149.484 432 68 350.516 68 250C68 149.484 149.484 68 250 68C350.516 68 432 149.484 432 250Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M243.5 367.6C239 341.8 220.7 309.4 185.9 283.3C168.8 270.4 151.4 262 134.3 258.4V245.8C168.2 237.7 201.5 214.9 222.8 184C233.6 168.4 240.5 153.1 243.5 137.2H256.1C261.2 167.5 284.6 201.1 316.4 223.6C332 234.7 348.2 242.2 364.7 245.8V258.4C331.4 265.3 292.7 295 273.5 325.3C263.9 340.6 258.2 354.7 256.1 367.6H243.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstraLogo);
export default __webpack_public_path__ + "static/media/astraLogo.1d6eaab06f7db6732d16d13464cfa5f3.svg";
export { ForwardRef as ReactComponent };